/** Single source of truth for product-status badge colors and labels.
 *  Seed-only products get a distinct orange warning: the "soap gene"
 *  mainly reacts to coriander leaf, and many haters tolerate seed. */
export const statusBadgeStyle = (product) => {
  if (product.status === 'safe') {
    return { background: '#e8f5e9', color: '#1b5e20', label: '✓ Safe' };
  }
  if (product.seed_only) {
    return { background: '#fff3e0', color: '#e65100', label: '⚠ Seeds Only' };
  }
  return { background: '#ffebee', color: '#b71c1c', label: '⚠ Contains Cilantro' };
};
